var v4 = '(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(?:\\.(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){3}';
var v6seg = '[0-9a-fA-F]{1,4}';
var v6 = "\n(\n(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)|                                // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:").concat(v6seg, ":){6}(?:").concat(v4, "|:")
	.concat(v6seg, "|:)|                         // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:")
	.concat(v6seg, ":){5}(?::")
	.concat(v4, "|(:")
	.concat(v6seg, "){1,2}|:)|                 // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:")
	.concat(v6seg, ":){4}(?:(:")
	.concat(v6seg, "){0,1}:")
	.concat(v4, "|(:")
	.concat(v6seg, "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:")
	.concat(v6seg, ":){3}(?:(:")
	.concat(v6seg, "){0,2}:")
	.concat(v4, "|(:")
	.concat(v6seg, "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:")
	.concat(v6seg, ":){2}(?:(:")
	.concat(v6seg, "){0,3}:")
	.concat(v4, "|(:")
	.concat(v6seg, "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:")
	.concat(v6seg, ":){1}(?:(:")
	.concat(v6seg, "){0,4}:")
	.concat(v4, "|(:")
	.concat(v6seg, "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::((?::")
	.concat(v6seg, "){0,5}:")
	.concat(v4, "|(?::")
	.concat(v6seg, "){1,7}|:))           // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(%[0-9a-zA-Z]{1,})?                                           // %eth0            %1\n")
	.replace(/\s*\/\/.*$/gm, '')
	.replace(/\n/g, '')
	.trim();

var ip = function (opts) {
	return opts && opts.exact ? new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)")) : new RegExp("(?:".concat(v4, ")|(?:").concat(v6, ")"), 'g');
};

ip.v4 = function (opts) {
	return opts && opts.exact ? new RegExp("^".concat(v4, "$")) : new RegExp(v4, 'g');
};

ip.v6 = function (opts) {
	return opts && opts.exact ? new RegExp("^".concat(v6, "$")) : new RegExp(v6, 'g');
};

var ipv4 = ip.v4().source + "\\/(3[0-2]|[12]?[0-9])";
var ipv6 = ip.v6().source + "\\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])";

var cidr = function (opts) {
	return opts && opts.exact ? new RegExp("(?:^".concat(ipv4, "$)|(?:^").concat(ipv6, "$)")) : new RegExp("(?:".concat(v4, ")|(?:").concat(v6, ")"), "g");
};

cidr.v4 = function (opts) {
	return opts && opts.exact ? new RegExp("^".concat(ipv4, "$")) : new RegExp(ipv4, "g");
};

cidr.v6 = function (opts) {
	return opts && opts.exact ? new RegExp("^".concat(ipv6, "$")) : new RegExp(ipv6, "g");
};

module.exports = cidr;
